{
  "accept": "כן",
  "account_is_inactive": "החשבון שלכם אינו פעיל.",
  "addRule": "הוספת כלל",
  "after": "אחרי",
  "analytics_chart_frequency_d": "יומי",
  "analytics_chart_frequency_h": "שעתי",
  "analytics_chart_frequency_m": "חודשי",
  "analytics_chart_frequency_w": "שבועי",
  "analytics_charts": "טבלאות",
  "analytics_date": "תאריך",
  "analytics_description_empty": "אין נתונים עבור התקופה שנבחרה.",
  "analytics_event_bounce": "הוחזרו",
  "analytics_event_clicks": "נלחצו",
  "analytics_event_delivered": "נמסרו",
  "analytics_event_drop": "בוטלו",
  "analytics_event_opens": "נפתחו",
  "analytics_event_queued": "תור",
  "analytics_event_sent": "נמסרו",
  "analytics_event_spam": "דואר זבל",
  "analytics_event_unsubscribes": "ביטולי הרשמה",
  "analytics_events": "אירועים",
  "analytics_events_all": "הכל",
  "analytics_events_bounce": "הוחזרו",
  "analytics_events_bounce_tooltip": "האחוז ומספר הודעות הדוא\"ל שנדחו על ידי שרתי הנמענים שלכם.",
  "analytics_events_bounces": "חזרות",
  "analytics_events_clicks": "נלחצו",
  "analytics_events_clicks_tooltip": "האחוז ומספר האנשים שלחצו על קישור אחד לפחות בהודעה שלכם.",
  "analytics_events_delivered": "נמסרו",
  "analytics_events_delivered_tooltip": "האחוז ומספר ההודעות שנמסרו לנמענים שלכם.",
  "analytics_events_drop": "בוטלו",
  "analytics_events_opens": "נפתחו",
  "analytics_events_opens_tooltip": "האחוז ומספר הודעות הדוא\"ל שנפתחו על ידי הנמענים שלכם.",
  "analytics_events_queued": "תור",
  "analytics_events_sent": "נמסרו",
  "analytics_events_spam": "דואר זבל",
  "analytics_events_unsubscribes": "ביטולי הרשמה",
  "analytics_file": "שם הקובץ",
  "analytics_filterby_domain": "דומיין",
  "analytics_filterby_recipient": "נמען",
  "analytics_filterby_sender": "שולח",
  "analytics_filterby_subject": "נושא",
  "analytics_overview": "סקירה כללית",
  "analytics_recipient": "נמען",
  "analytics_sender": "שולח",
  "analytics_status": "סטטוס",
  "analytics_subject": "נושא",
  "analytics_temporary_error": "אירעה שגיאה זמנית. נא לנסות שוב מאוחר יותר.",
  "analytics_title": "ניתוח נתונים",
  "analytics_total_emails": "דוא\"ל שהועלה",
  "analytics_total_processed": "דוא\"ל שעובד",
  "analytics_upload_date": "תאריך העלאה",
  "and": "ו-",
  "annually": "שנתית",
  "apply": "להחיל",
  "authentication_expired": "פג תוקף ההפעלה שלכם. אנא היכנסו שוב.",
  "before": "לפני",
  "billing_changepassword_description": "שנה את הסיסמה שלך באזור זה. סיסמה זו משמשת רק לגישה ללוח הבקרה.",
  "billing_changepassword_title": "שינוי סיסמה",
  "billing_contact_were_not_found": "לא נמצא איש קשר לחיוב.",
  "billing_contacts_address": "כתובת",
  "billing_contacts_address2": "כתובת 2",
  "billing_contacts_billing": "הודעות דוא\"ל לחשבוניות - חשבוניות ותזכורות חיוב",
  "billing_contacts_button_add": "הוספה",
  "billing_contacts_button_edit": "עריכה",
  "billing_contacts_city": "עיר",
  "billing_contacts_company": "שם חברה",
  "billing_contacts_country": "מדינה",
  "billing_contacts_editcontact": "עריכת פרטי איש קשר",
  "billing_contacts_email": "כתובת דוא\"ל",
  "billing_contacts_empty": "הודאות דוא\"ל יישלחו לכתובת בחשבון הראשי שלכם. יש להזין כתובות נוספות כדי לשלוח הודעות לנמענים נוספים.",
  "billing_contacts_firstname": "שם פרטי",
  "billing_contacts_lastname": "שם משפחה",
  "billing_contacts_marketing": "הודעות דוא\"ל שירות - הודעות חידוש, אישורי רישום וכו'.",
  "billing_contacts_phone": "מספר טלפון",
  "billing_contacts_products": "הודעות דוא\"ל למוצר - פרטי הזמנה, הודעות דוא\"ל לקבלת פנים וכו'.",
  "billing_contacts_slide_description": "הודאות דוא\"ל יישלחו לכתובת בחשבון הראשי שלכם. יש להזין כתובות נוספות כדי לשלוח הודעות לנמענים נוספים.",
  "billing_contacts_slide_title": "הוספת איש קשר חדש",
  "billing_contacts_stateregion": "מדינה/אזור/מחוז",
  "billing_contacts_support": "הודעות דוא\"ל תמיכה - יש לאפשר למשתמש זה לפתוח כרטיסים בחשבון שלכם.",
  "billing_contacts_terms": "קראתי ואני מסכים/ה ל'מדיניות הפרטיות' ו'התנאים וההגבלות'",
  "billing_contacts_title": "הוספת אנשי קשר",
  "billing_contacts_transactional": "הודעות דוא\"ל כלליות - הודעות כלליות ותזכורות סיסמאות",
  "billing_contacts_zip": "מיקוד",
  "billing_details_contact_above": "לשלוח רק לאיש הקשר המוגדר כברירת מחדל",
  "billing_emails_sentdate": "תאריך שליחה",
  "billing_emails_subject": "נושא",
  "billing_invoice_date": "תאריך שליחה",
  "billing_invoice_duedate": "תאריך יעד",
  "billing_invoice_number": "מספר",
  "billing_invoice_status": "סטטוס",
  "billing_invoice_status_cancelled": "מבוטל",
  "billing_invoice_status_paid": "שולם",
  "billing_invoice_status_refunded": "זוכה",
  "billing_invoice_status_unpaid": "לא שולם",
  "billing_invoice_total": "סך הכול",
  "billing_product_payment_method_banktransfer": "העברה בנקאית",
  "billing_product_paymentmethod_avangate": "כרטיס אשראי (2Checkout)",
  "billing_product_paymentmethod_stripe": "כרטיס אשראי (Stripe)",
  "button_add_contact": "הוספת איש קשר",
  "button_add_filter": "הוספת מסנן",
  "button_add_plan": "הזמנת תוכנית חדשה",
  "button_add_subaccount": "הוספת חשבון משנה",
  "button_add_suppression": "הוספת חסימה",
  "button_add_template": "הוספת תבנית",
  "button_addbcc": "הוספת עותק מוסתר",
  "button_addfooter": "הוספת כותרת תחתונה",
  "button_advanced_search": "חיפוש מתקדם",
  "button_apply": "להחיל",
  "button_back": "חזרה",
  "button_basic_search": "חיפוש בסיסי",
  "button_buycredits": "רכישת נקודות זכות",
  "button_cancel": "ביטול",
  "button_close": "סגירה",
  "button_create": "יצירה",
  "button_createalert": "יצירת התראה",
  "button_delete": "מחיקה",
  "button_delete_all": "למחוק הכל",
  "button_delete_filtered": "למחוק את המסוננים",
  "button_delete_selected": "מחיקת ({n}) שנבחרו",
  "button_edit": "עריכה",
  "button_export": "ייצוא",
  "button_import": "יבוא קובץ",
  "button_limits": "הגדרת מגבלות",
  "button_more": "עוד",
  "button_next": "הבא",
  "button_refresh": "ריענון",
  "button_request_cancellation": "בקשת ביטול",
  "button_reset": "איפוס",
  "button_returnlist": "חזרה לרשימה",
  "button_save": "שמירה",
  "button_search": "חיפוש",
  "button_select_fromdevice": "בחירת קבצים מהמכשיר שלכם",
  "button_unsubscribe": "הוספת קישור לביטול ההרשמה",
  "button_update": "עדכון",
  "button_update_template": "עדכון תבנית",
  "button_update_unsubscribe": "עדכון קישור לביטול ההרשמה",
  "button_updatealert": "עדכון התראה",
  "button_updatebcc": "עדכון עותק מוסתר",
  "button_updatefooter": "עדכון כותרת תחתונה",
  "cancel": "ביטול",
  "choose": "בחירה",
  "clear": "ניקוי",
  "confirm_password_is_missing": "אישור סיסמה' הוא חובה.",
  "contains": "מכיל",
  "dashboard_clicked": "נלחצו",
  "dashboard_delivered": "נמסרו",
  "dashboard_emails_sent": "הודעות דוא\"ל שנשלחו",
  "dashboard_emails_sent_out_of": "הודעות דוא\"ל שנשלחו מתוך",
  "dashboard_gotoanalytics": "מעבר לניתוחי נתונים",
  "dashboard_new_version": "גרסה מעודכנת זמינה!",
  "dashboard_new_version_cancel": "אישור",
  "dashboard_new_version_description": "תחילה שמרו את העבודה שלכם ואז טענו מחדש את הדף,<br> או לחצו על \"לעדכן כעת\" כדי לטעון גרסה חדשה.",
  "dashboard_new_version_ok": "לעדכן כעת",
  "dashboard_plan_emails": "דוא\"ל",
  "dashboard_plan_label": "תכנית",
  "dashboard_plan_label_interval": "תכנית {interval}",
  "dashboard_plan_limit_unit_daily": "יום",
  "dashboard_plan_limit_unit_monthly": "חודש",
  "dashboard_plan_limit_unit_yearly": "שנה",
  "dashboard_recent_email_activities": "פעילויות דוא\"ל אחרונות",
  "dashboard_try": "אתם משתמשים ב\"ניסיון חינם\". לצפייה בלוח המחוונים המלא:",
  "dateAfter": "התאריך הוא אחרי",
  "dateBefore": "התאריך הוא לפני",
  "dateIs": "התאריך הוא",
  "dateIsNot": "התאריך הוא לא",
  "datepicker_last_3_months": "שלושת החודשים האחרונים",
  "datepicker_last_30days": "30 הימים האחרונים",
  "datepicker_last_month": "החודש האחרון",
  "datepicker_last_sevendays": "השבוע האחרון",
  "datepicker_last_week": "השבוע שעבר",
  "datepicker_last_year": "השנה שעברה",
  "datepicker_this_month": "החודש הזה",
  "datepicker_this_year": "השנה",
  "datepicker_today": "היום",
  "datepicker_yesterday": "אתמול",
  "delete_all_bounce": "למחוק את כל ההחזרות",
  "delete_all_manual": "למחוק את כל הידניים",
  "delete_all_spam": "למחוק את כל דואר הזבל",
  "delete_all_unsubscribe": "למחוק את כל ביטולי ההרשמה",
  "delete_fist_login_dont": "לא להציג לי הודעה זו שוב.",
  "delete_fist_login_one": "<h3>ברוכים הבאים ללוח המחוונים המתקדם של turboSMTP.</h3><p>צפו בנתונים סטטיסטיים בזמן אמת אודות הקמפיינים שלכם בדוא\"ל<br>ושפרו את התוצאות שלכם באמצעות כלים מקצועיים.</p><h4>אנא פעלו על פי ההוראות כדי להגדיר את הפאנל שלכם.</h4>",
  "delete_fist_login_three_a": "אנא הזינו את שם שרת ה-SMTP בתוכנת הדוא\"ל שלכם.",
  "delete_fist_login_three_b": "<p><strong class=\"font-xxl\">pro.turbo-smtp.com</strong></p>",
  "delete_fist_login_three_c": "אל תשכחו להגדיר את רשומות ה-DNS של הדומיין שלכם. <br>מצאו את הפרמטרים ב'הגדרות' שלכם.",
  "delete_fist_login_two_a": "<h3>פתיחת מעקב</h3><p>מאפשר ל-turboSMTP לעקוב אחר שיעורי פתיחת ההודעות שלכם.</p>",
  "delete_fist_login_two_b": "<h3>מעקב אחר קליקים</h3><p>מאפשר ל-turboSMTP לעקוב אחר שיעורי הקליקים בהודעות שלכם.</p>",
  "editor_quill_button_title": "הצגת מקור HTML",
  "editor_quill_cancel_text": "ביטול",
  "editor_quill_msg": "עריכת התוכן בפורמט HTML",
  "editor_quill_ok_text": "אישור",
  "emails_month": "הודעות דוא\"ל בחודש",
  "emailvalidator_add_file": "הוספת קובץ",
  "emailvalidator_add_form_errors": "שגיאות טפסים",
  "emailvalidator_add_form_nofile_selected": "לא נבחר אף קובץ",
  "emailvalidator_add_value": "באפשרותכם להוסיף בין",
  "emailvalidator_attention": "שימו לב!",
  "emailvalidator_available": "נקודות זכות בחינם",
  "emailvalidator_balance_description": "יתרת נקודות הזכות שלכם היא",
  "emailvalidator_balance_title": "יתרת האימות שלכם",
  "emailvalidator_buy_extra_credit": "רכישת נקודות זכות נוספות",
  "emailvalidator_complete": "הושלם",
  "emailvalidator_confirm_delete_label": "אישור פעולה",
  "emailvalidator_confirm_delete_text": "האם אתם בטוחים שברצונכם למחוק רשימה זו?",
  "emailvalidator_contact_support": "<a href=\"https://serversmtp.com/en/submitticket.php\" target=\"_blank\">צרו קשר עם התמיכה <i class=\"ml-2 pi pi-external-link\"></i></a>",
  "emailvalidator_cost_per_email": "העלות לדוא\"ל היא",
  "emailvalidator_date": "תאריך יצירה:",
  "emailvalidator_day": "יום",
  "emailvalidator_details_empty": "אין אלמנטים בפנים",
  "emailvalidator_domain": "דומיין",
  "emailvalidator_domain_age": "גיל הדומיין",
  "emailvalidator_email": "דוא\"ל",
  "emailvalidator_email_addesses": "כתובות דוא\"ל",
  "emailvalidator_empty": "על קובץ שהועלה להכיל כתובת דוא\"ל אחת בלבד בכל שורה. הפורמטים המותרים של הקבצים הם csv ו-txt. או בחרו קובץ להעלאה.",
  "emailvalidator_entry_details": "פרטי אימות",
  "emailvalidator_error": "שגיאה",
  "emailvalidator_error_contact_support": "שגיאה: צרו קשר עם התמיכה!",
  "emailvalidator_expiring": "יפוג ב-",
  "emailvalidator_export": "ייצוא",
  "emailvalidator_free_email": "דוא\"ל חינם",
  "emailvalidator_how_many": "כמה כתובות דוא\"ל ברצונכם לאמת?",
  "emailvalidator_list_contains": "הרשימה שהועלתה מכילה",
  "emailvalidator_list_not_removed": "שגיאה בהסרת הרשימה",
  "emailvalidator_list_removed": "הרשימה הוסרה בהצלחה.",
  "emailvalidator_mx_record": "רשומת MX",
  "emailvalidator_please_enter_amout": "נא להזין את הסכום שברצונכם להוסיף לארנק הווירטואלי שלכם.",
  "emailvalidator_price_calculator": "מחשבון מחירים",
  "emailvalidator_price_email": "מחיר לדוא\"ל",
  "emailvalidator_process_now": "לעבד עכשיו",
  "emailvalidator_refresh": "ריענון",
  "emailvalidator_slide_description": "על הקובץ להיות עמודה אחת המכילה את כל כתובות הדוא\"ל שברצונכם לייבא.",
  "emailvalidator_slide_details_description": "הפורמטים המותרים של הקבצים הם csv או txt.",
  "emailvalidator_slide_details_title": "גררו ושחררו את הקובץ שלכם כאן.",
  "emailvalidator_slide_manually_description": "העתיקו והדביקו מספר כתובות דוא\"ל באזור למטה, מופרדות על ידי קו סיום.",
  "emailvalidator_slide_manually_title": "הוספה ידנית",
  "emailvalidator_smpt_provider": "ספק SMTP",
  "emailvalidator_status": "סטטוס",
  "emailvalidator_status_abuse": "ניצול לרעה",
  "emailvalidator_status_catch_all": "תופס הכל",
  "emailvalidator_status_do_not_mail": "לא לשלוח דואר",
  "emailvalidator_status_invalid": "לא חוקי",
  "emailvalidator_status_spamtrap": "דואר זבל",
  "emailvalidator_status_unknown": "לא ידוע",
  "emailvalidator_status_valid": "חוקי",
  "emailvalidator_title": "מאמת דוא\"ל",
  "emailvalidator_total_cost": "העלות הכוללת היא",
  "emailvalidator_upload_warning": "יתרת נקודות הזכות הנוכחית שלכם היא {current_balance}. עליכם לרכוש {needed_balance} נקודות זכות נוספות כדי לאמת רשימה זו...",
  "emailvalidator_validate_list": "אימות רשימה",
  "emailvalidator_validate_now": "לאמת כעת",
  "emailvalidator_validated_lists": "רשימות מאומתות",
  "emailvalidator_validation_date": "תאריך אימות",
  "emailvalidator_value": "ערך",
  "emailvalidator_you_have": "יש לכם",
  "empty_authorization_token": "אסימון ההרשאה חסר",
  "empty_request_body": "הבקשה אינה שלמה",
  "endsWith": "מסתיים ב-",
  "equals": "שווה",
  "error": "שגיאה",
  "file_too_large": "file_too_large",
  "filter": "מסנן",
  "filter_by": "סינון לפי",
  "filter_fuzzy": "חיפוש חכם",
  "filter_fuzzy_description": "הפעילו תכונה זו כדי להחזיר פריטים הדומים למונח החיפוש.",
  "filter_placeholder_analytics": "חיפוש…",
  "filter_placeholder_suppressions": "חיפוש…",
  "filter_suppressions_placeholder": "חפשו לפי נמען, שולח, נושא דוא\"ל או סיבה לחסימה.",
  "filters_show": "הצג מסננים",
  "filters_hide": "הסתר מסננים",
  "first_login_step": "שלב {n}",
  "forgot_password_changed": "הסיסמה שלכם שונתה בהצלחה.",
  "forgot_password_click": "לחצו כאן",
  "forgot_password_confirm": "אשרו את סיסמתכם",
  "forgot_password_done": "בוצע!",
  "forgot_password_donot_match": "הסיסמאות אינן תואמות.",
  "forgot_password_email_not_found": "כתובת הדוא\"ל לא נמצאה",
  "forgot_password_enter_email": "נא להזין את כתובת הדוא\"ל שלכם",
  "forgot_password_error": "אירעה שגיאה בעת שינוי הסיסמה שלכם.",
  "forgot_password_expired": "פג תוקף הדוא\"ל לאיפוס הסיסמה שלכם.",
  "forgot_password_pick": "בחרו סיסמה",
  "forgot_password_please_reset": "אנא הגדירו את הסיסמה שלכם",
  "forgot_password_recovery_email_sent": "דוא\"ל השחזור נשלח",
  "forgot_password_resend": "לשליחת הדוא\"ל שוב.",
  "forgot_password_reset": "איפוס הסיסמה שלכם",
  "forgot_password_send_password_reset_link": "שליחת קישור לאיפוס סיסמה",
  "forgot_password_sent_email_to_update_password": "שלחנו לכם הודעת דוא\"ל עם קישור על מנת לעדכן את סיסמתכם.",
  "forgot_password_set": "הגדירו את סיסמתכם החדשה",
  "forgot_password_should_have": "על הסיסמה להכיל",
  "forgot_password_suggestions": "<li>לפחות אות קטנה אחת</li> <li>לפחות אות גדולה אחת</li><li>לפחות מספר אחד</li><li>לכל הפחות 10 תווים</li>",
  "forgot_password_switch": "מעבר לכניסה",
  "forgot_password_switch_to_login": "מעבר לכניסה",
  "forgot_password_token_is_missing": "חסר אסימון 'שכחתי סיסמה'",
  "forgot_password_unable_to_send": "לא ניתן לשלוח את הודעת הדוא\"ל.",
  "forgot_password_username": "שם משתמש כתובת דוא\"ל",
  "forgot_password_we_will_send_you": "אנו נשלח לכם קישור לשחזור סיסמה.",
  "free_account": "חשבון חינם",
  "friday": "יום שישי",
  "fuzzy_tooltip": "הפעילו תכונה זו כדי להחזיר פריטים הדומים למונח החיפוש",
  "gt": "גדול מ-",
  "gte": "גדול מ- או שווה ל-",
  "header_menu_support": "https://serversmtp.com/multilanguage-customer-support/",
  "internal_server_error_try_again": "התרחשה שגיאת שרת פנימית. נא לנסות שוב מאוחר יותר.",
  "invalid_authorization_token": "אסימון ההרשאה אינו חוקי",
  "invalid_limit_parameter_value_must_be_greater_than_or_equals_1": "על ערך ההגבלה להיות לפחות 1",
  "invalid_page_parameter_value_must_be_greater_than_or_equals_1": "על ערך הדף להיות לפחות 1",
  "invalid_value_for_orderby_parameter": "הפרמטר 'לסדר לפי' אינו חוקי.",
  "invalid_value_for_the_parameter_type": "ערך לא חוקי עבור סוג הפרמטר",
  "invoice_not_found": "החשבונית לא נמצאה",
  "is": "הינו",
  "isNot": "איננו",
  "jwt_error_full_details": "פרטים מלאים",
  "jwt_error_status": "סטטוס HTTP",
  "jwt_error_url": "כתובת URL",
  "jwt_url_not_exists": "כתובת ה-URL הבאה לא קיימת",
  "l_dont_have_account": "עדיין אין לכם חשבון?",
  "l_email_address": "כתובת דוא\"ל",
  "l_forgot_password": "שכחתם את הסיסמה?",
  "l_login": "התחברות",
  "l_password": "סיסמה",
  "l_remember_me": "השאירו אותי מחובר",
  "l_sign_up_here": "הירשמו כאן",
  "l_username_email": "שם משתמש כתובת דוא\"ל",
  "l_welcome_back": "ברוך שובכם",
  "language_changed_label": "שיניתם את השפה",
  "language_changed_message": "כדי להחיל שינויי שפה, יש לטעון מחדש את הדף",
  "language_changed_reload": "טעינה מחדש",
  "lt": "פחות מ-",
  "lte": "פחות מ- או שווה ל-",
  "m_accountinfo": "פרטי חשבון",
  "m_analytics": "ניתוח נתונים",
  "m_billing": "חשבוניות פרופורמה",
  "m_dashboard": "לוח מחוונים",
  "m_emailsentout": "הודעות דוא\"ל שנשלחו",
  "m_emailvalidator": "מאמת דוא\"ל",
  "m_messages": "הודעות מערכת",
  "m_myaccount": "החשבון שלי",
  "m_mydetails": "החשבון שלי",
  "m_noplans": "אין תוכניות",
  "m_of": "מתוך",
  "m_products": "המוצרים שלי",
  "m_savechanges": "שמירת שינויים",
  "m_settings": "הגדרות",
  "m_subaccounts": "חשבונות משנה",
  "m_suppressions": "חסימות",
  "m_tickets": "הכרטיסים שלי",
  "m_validuntil": "בתוקף עד",
  "max_limit_reached": "הגעת למספר המרבי של חשבונות משנה שניתן להפעיל בתוכנית הנוכחית שלך.",
  "matchAll": "להתאים את כולם",
  "matchAny": "להתאים כל אחד",
  "missing_or_invalid_value_provided_for_whiteLabeled_variable": "ערך חסר או לא חוקי סופק עבור משתנה WhiteLabeled",
  "missing_required_parameter": "חסר פרמטר נדרש",
  "missing_required_parameter_email": "הדוא\"ל חסר",
  "missing_required_parameter_from": "חסרים פרטי 'מאת'",
  "missing_required_parameter_to": "חסרים פרטי 'אל'",
  "missing_required_parameter_tz": "חסרים פרטי 'tz'",
  "modal_confirmation": "אישור",
  "monday": "יום שני",
  "monthly": "חודשי",
  "my_account_title": "החשבון שלי",
  "myaccount_2fa_title": "אימות דו-שלבי",
  "myaccount_2fa_description": "חזק את אבטחת החשבון שלך על ידי הפעלת אימות דו-שלבי (2FA). פעולה זו מוסיפה שכבת הגנה נוספת לחשבונך.",
  "myaccount_2fa_card_description": "הפעל אימות דו-שלבי כדי להגן על חשבונך.",
  "myaccount_2fa_select_method": "בחר שיטת אימות",
  "myaccount_2fa_method": "שיטת אימות",
  "myaccount_2fa_method_placeholder": "בחר שיטת אימות",
  "myaccount_2fa_otp_description": "השתמש באפליקציית אימות (כגון Google Authenticator או Authy) ליצירת קודים מבוססי זמן.",
  "myaccount_2fa_email_description": "קבל קודי אימות בדוא\"ל.",
  "myaccount_2fa_sms_description": "קבל קודי אימות ב-SMS.",
  "myaccount_2fa_none_description": "בטל את האימות הדו-שלבי עבור חשבונך.",
  "myaccount_2fa_scan_qr": "סרוק קוד QR",
  "myaccount_2fa_scan_qr_description": "סרוק את קוד ה-QR הזה באמצעות אפליקציית האימות שלך להגדרת אימות דו-שלבי.",
  "myaccount_2fa_manual_entry": "או הזן קוד זה ידנית:",
  "myaccount_2fa_copy_secret": "העתק ללוח",
  "myaccount_2fa_secret_copied": "המפתח הסודי הועתק ללוח",
  "myaccount_2fa_verify_code": "אמת קוד",
  "myaccount_2fa_enter_code": "הזן קוד אימות",
  "myaccount_2fa_code_placeholder": "000000",
  "myaccount_2fa_verify_code_description": "הזן את הקוד בן 6 הספרות מאפליקציית האימות שלך להשלמת ההגדרה.",
  "myaccount_2fa_method_updated": "שיטת האימות הדו-שלבי עודכנה בהצלחה",
  "myaccount_2fa_otp_enabled": "האימות הדו-שלבי הופעל בהצלחה",
  "myaccount_2fa_current_status": "מצב נוכחי",
  "myaccount_2fa_status": "סטטוס אימות דו-שלבי",
  "myaccount_2fa_status_disabled": "מושבת",
  "myaccount_2fa_error_no_keycloak_id": "לא ניתן להגדיר 2FA: מזהה המשתמש לא נמצא",
  "myaccount_2fa_error_invalid_code": "קוד אימות שגוי. אנא נסה שנית.",
  "myaccount_2fa_error_generic": "אירעה שגיאה בעת הגדרת האימות הדו-שלבי",
  "myaccount_2fa_enabled": "מופעל",
  "myaccount_2fa_disabled_label": "מושבת",
  "myaccount_2fa_disabled": "האימות הדו-שלבי בוטל בהצלחה",
  "myaccount_account_details": "החשבון שלי",
  "myaccount_billing": "חשבוניות פרופורמה",
  "myaccount_billing_contacts": "ניהול אנשי קשר",
  "myaccount_billing_contacts_description": "כל הודאות הדוא\"ל יישלחו לכתובת בחשבון הראשי שלכם. יש להזין כתובות נוספות כדי לשלוח הודעות לנמענים נוספים.",
  "myaccount_billing_description": "באזור זה תוכלו למצוא את חשבוניות הפרופורמה שהופקו לפני חשבוניות מס.<br>nחשבוניות מס יישלחו אליכם בדוא\"ל.",
  "myaccount_billing_details": "פרטי חשבון וחיוב",
  "myaccount_billing_details_address": "כתובת",
  "myaccount_billing_details_address2": "כתובת 2",
  "myaccount_billing_details_billing_company_name": "החברה המחייבת",
  "myaccount_billing_details_billing_contact": "שלחו חשבוניות פרופורמה לכתובת שאינה כתובת החשבון",
  "myaccount_billing_details_billing_vat": "מע\"מ / P.IVA / CF",
  "myaccount_billing_details_billing_website": "אתר",
  "myaccount_billing_details_city": "עיר",
  "myaccount_billing_details_country": "מדינה",
  "myaccount_billing_details_description": "שינוי פרטי החשבון וכתובת החיוב שלכם.",
  "myaccount_billing_details_details": "פרטי החיוב",
  "myaccount_billing_details_email": "כתובת דוא\"ל",
  "myaccount_billing_details_fistname": "שם פרטי",
  "myaccount_billing_details_lastname": "שם משפחה",
  "myaccount_billing_details_marketing": "אני רוצה לקבל הצעות וטיפים ייעודיים מ-turboSMTP",
  "myaccount_billing_details_phone_number": "מספר טלפון",
  "myaccount_billing_details_policy": "קראתי ואני מסכים/ה למדיניות הפרטיות והתנאים וההגבלות",
  "myaccount_billing_details_state": "אזור/מחוז",
  "myaccount_billing_details_zip": "מיקוד",
  "myaccount_billing_slides_description": "כאן תוכלו למצוא את 'חשבוניות פרופורמה' הקשורות לחשבון שלכם.",
  "myaccount_billing_cancellation_select_reason": "בחר סיבה",
  "myaccount_billing_slides_nodata": "לא נמצאו חשבוניות פרופורמה",
  "myaccount_billingcontacts_added": "איש קשר לחיוב נוסף בהצלחה",
  "myaccount_billingcontacts_deleted": "איש קשר לחיוב נמחק בהצלחה",
  "myaccount_billingcontacts_edited": "איש קשר לחיוב נערך בהצלחה",
  "myaccount_billingdetails_updated": "פרטי החיוב עודכנו",
  "myaccount_change_password": "שינוי סיסמה",
  "myaccount_confirm_delete_selectedcontact_label": "אישור פעולה",
  "myaccount_confirm_delete_selectedcontact_text": "האם אתם בטוחים שברצונכם למחוק איש קשר זה?",
  "myaccount_confirm_password": "אימות סיסמה",
  "myaccount_current_password": "אמתו את הסיסמה הנוכחית",
  "myaccount_language": "שפת התצוגה",
  "myaccount_language_change": "שינוי שפה",
  "myaccount_language_description": "TurboSMTP זמין כעת באנגלית ובאיטלקית. (צרפתית, גרמנית, עברית, פורטוגזית, רוסית, ערבית וספרדית בקרוב).",
  "myaccount_language_select": "בחרו שפה",
  "myaccount_messages": "הודעות מערכת",
  "myaccount_messages_nomessages_description": "בסעיף זה תמצאו את ההודעות שהמערכת שלנו שלחה לחשבונכם.",
  "myaccount_new_password": "סיסמה חדשה",
  "myaccount_password_changed": "הסיסמה שונתה בהצלחה",
  "myaccount_password_choose": "בחרו את הסיסמה החדשה שלכם",
  "myaccount_password_notmatch": "סיסמאות אלה אינן תואמות. נסו פעם נוספת.",
  "myaccount_password_suggestions": "על סיסמאות להכיל לפחות 10 תווים, כולל אותיות גדולות וקטנות ולפחות מספר אחד.",
  "myaccount_product_delete_label": "אישור פעולה",
  "myaccount_product_delete_text": "האם אתם בטוחים שברצונכם לבטל את המוצר הזה?",
  "myaccount_products": "המוצרים שלי",
  "myaccount_products_billingcycle": "מחזור חיוב",
  "myaccount_products_cycle_annually": "שנתית",
  "myaccount_products_cycle_biennally": "דו-שנתי",
  "myaccount_products_cycle_free_account": "חשבון חינם",
  "myaccount_products_cycle_month": "חודשי",
  "myaccount_products_cycle_monthly": "חודשי",
  "myaccount_products_cycle_one_time": "חד פעמי",
  "myaccount_products_cycle_onetime": "חד פעמי",
  "myaccount_products_cycle_quarterly": "רבעוני",
  "myaccount_products_cycle_semi-annually": "חצי שנתי",
  "myaccount_products_cycle_triennially": "תלת שנתי",
  "myaccount_products_cycle_year": "שנתי",
  "myaccount_products_cycle_yearly": "שנתי",
  "myaccount_products_fistpayment": "סכום תשלום ראשון",
  "myaccount_products_nextduedate": "תאריך היעד הבא",
  "myaccount_products_noproduct_description": "בסעיף זה תמצאו את המוצרים והשירותים המשויכים לחשבון.",
  "myaccount_products_payment": "אמצעי תשלום",
  "myaccount_products_price": "מחיר",
  "myaccount_products_productservice": "מוצר/שירות",
  "myaccount_products_recurringamount": "סכום חוזר",
  "myaccount_products_registration": "תאריך הרשמה",
  "myaccount_products_slide_productservice_description": "נהלו את המוצר שלכם ישירות מאזור זה.",
  "myaccount_products_status": "סטטוס",
  "plans_addon_options_title": "תוכניות נוספות",
  "plans_available_recurring_options_title": "תוכניות זמינות",
  "plans_billing_cycle": "מחזור חיוב",
  "plans_current_plans_title": "התוכניות הנוכחיות שלך",
  "plans_cycle_month": "חודשי",
  "plans_cycle_monthly": "חודשי",
  "plans_cycle_onetime": "חד פעמי",
  "plans_cycle_year": "שנתי",
  "plans_cycle_yearly": "שנתי",
  "plans_downgrade_options_title": "אפשרויות הורדת דרגה",
  "plans_feature_dedicated_ip": "IP ייעודי",
  "plans_feature_email_credits": "קרדיטים לאימייל",
  "plans_feature_smtp_limit": "מגבלת SMTP",
  "plans_features": "תכונות",
  "plans_invoice_created": "החשבונית נוצרה בהצלחה.",
  "plans_invoice_error": "לא ניתן ליצור חשבונית. נסה שוב.",
  "plans_load_error": "לא ניתן לטעון את אפשרויות התוכנית. נסה שוב.",
  "plans_onetime_options_title": "תוכניות חד פעמיות",
  "plans_plan_name": "שם התוכנית",
  "plans_plan_type": "סוג התוכנית",
  "plans_select_plan": "בחר תוכנית",
  "plans_type_addon": "תוספת",
  "plans_type_onetime": "חד פעמי",
  "plans_type_recurring": "מחזורי",
  "plans_upgrade_options_title": "אפשרויות שדרוג",
  "myaccount_sentdate": "תאריך שליחה",
  "new_dashboard_error": "מצטערים, התרחשה שגיאה:",
  "new_dashboard_if_you_think": "אם אתם חושבים שאתם רואים הודעה זו בטעות, אנא <a href=\"https://serversmtp.com/contact-us/\" target=\"_blank\" >צרו קשר</a>.",
  "new_dashboard_not_allowed": "פנו <a href='https://serversmtp.com/contact-us/' target='_blank'>לצוות התמיכה</a> שלנו כדי להתחיל להשתמש בגרסת Beta Dashboard.",
  "new_dashboard_token_valid": "האסימון תקף",
  "new_dashboard_token_wrong": "האסימון שגוי",
  "new_dashboard_validating": "מאמתים את האסימון...",
  "no": "לא",
  "no_parameters_was_provided_for_update": "לא סופק פרמטר לעדכון",
  "no_suppression_data_were_provided": "לא סופקו נתוני חסימה",
  "noFilter": "אין מסנן",
  "notContains": "לא מכיל",
  "notEquals": "לא שווה",
  "one_time": "חד פעמי",
  "optional": "אופציונלי",
  "or": "או",
  "password_is_invalid": "אין חשבון שתואם את הסיסמה הזו",
  "password_is_missing": "חסרה סיסמה",
  "password_length_should_not_be_less_than_10_characters": "על סיסמה להכיל לפחות 10 תווים",
  "password_should_contain_at_least_one_uppercase_character": "הסיסמה חייבת להכיל לפחות 1 אות גדולה",
  "password_should_contain_at_least_one_lowercase_character": "הסיסמה חייבת להכיל לפחות 1 אות קטנה",
  "password_should_contain_at_least_one_digit": "הסיסמה חייבת להכיל לפחות 1 ספרה",
  "password_should_equals_to_confirm_password": "על הסיסמה והאימות להיות זהים",
  "plan_daily": "תוכנית יומית",
  "plan_monthly": "תוכנית חודשית",
  "plan_yearly": "תוכנית שנתית",
  "reject": "לא",
  "removeRule": "הסרת כלל",
  "saturday": "יום שבת",
  "server_error_please_try_again": "שגיאת שרת. נא לנסות שוב מאוחר יותר.",
  "server_error_while_performing_update": "אירעה שגיאת שרת במהלך ביצוע העדכון",
  "server_problem_gateway_timeout": "פג הזמן הקצוב של שער השרת, נא לנסות שוב.",
  "server_problem_please_retry": "בעיה בשרת, נא לנסות שוב.",
  "server_problem_unknown_error": "שגיאת שרת לא ידועה, נא לנסות שוב.",
  "settings_activities_description": "קבלו דוחות פעילות בחשבון בתיבת הדואר שלכם. הדוחות יכולים להיות יומיים, שבועיים ו/או חודשיים, ולכסות את כל פעילויות החשבון שלכם.",
  "settings_activities_slide_dailyreport": "דוח יומי",
  "settings_activities_slide_day": "יום",
  "settings_activities_slide_dayoftheweek": "יום בשבוע",
  "settings_activities_slide_description": "באפשרותכם לקבל דוחות יומיים, שבועיים וחודשיים עבור כל פעילויות החשבון שלכם. הדוח שלכם יישלח לכתובת הדוא\"ל הרשומה שלכם.",
  "settings_activities_slide_monthlyreport": "דו\"ח חודשי",
  "settings_activities_slide_time": "זמן",
  "settings_activities_slide_title": "דוחות פעילות",
  "settings_activities_slide_weeklyreport": "דו\"ח שבועי",
  "settings_activities_title": "דוחות פעילות",
  "settings_alert_usage_limit": "מגבלת שימוש",
  "settings_alerts_description": "קבלו התראה בדוא\"ל כאשר השתמשתם באחוז מסוים מנקודות הזכות שלכם עבור דוא\"ל.",
  "settings_alerts_slide_add": "הוספת התראה",
  "settings_alerts_slide_description": "כדי למנוע מהממסרים לאזול באמצע שליחת דואר, קבלו התראה בדוא\"ל כאשר אתם מגיעים לאחוז מוגדר מנקודות הזכות שלכם. אנו מציעים להפעיל את ההתראה ב-80% מנקודות הזכות הזמינות שלכם.",
  "settings_alerts_slide_empty_description": "הגדירו התראה שתישלח לכתובת הדוא\"ל שלכם כאשר תגיעו לאחוז מוגדר מנקודות הזכות שלכם.",
  "settings_alerts_slide_empty_title": "הוספת התראה",
  "settings_alerts_slide_frequency": "תדירות",
  "settings_alerts_slide_percentage": "אחוז",
  "settings_alerts_slide_placeholder": "למשל, name@address.com",
  "settings_alerts_slide_sendto": "שליחה אל",
  "settings_alerts_slide_title": "התראות",
  "settings_alerts_slide_type": "סוג התראה",
  "settings_alerts_title": "התראות",
  "settings_api_description": "שלחו את הודעות הדוא\"ל שלכם ישירות מהאתר או האפליקציה שלכם באמצעות turboSMTP API.",
  "settings_api_title": "תיעוד API",
  "settings_bccs_description": "כל כתובת דוא\"ל ברשימת העותקים המוסתרים תקבל עותק של כל הודעת דוא\"ל מבלי שהנמען יראה את הפרטים של נמענים אחרים.",
  "settings_bccs_enable": "אפשר להרשות חשבון דוא\"ל אחד לקבל עותק של כל הודעות הדוא\"ל שנשלחו",
  "settings_bccs_slide_add": "הוספת עותקים מוסתרים",
  "settings_bccs_slide_description": "אנא הגדירו ואשרו חשבון דוא\"ל אחד או יותר כדי לקבל עותק של הודעות דוא\"ל כלשהן.",
  "settings_bccs_slide_email": "דוא\"ל",
  "settings_bccs_slide_empty": "אנא הגדירו חשבון דוא\"ל אחד ואשרו אותו כדי לקבל עותק של הודעות דוא\"ל.",
  "settings_bccs_slide_empty_title": "הוספת כתובת עותק מוסתר",
  "settings_bccs_slide_name": "שם",
  "settings_bccs_slide_not_verified": "לא אומת",
  "settings_bccs_slide_status": "סטטוס",
  "settings_bccs_slide_title": "עותקים מוסתרים",
  "settings_bccs_slide_verified": "מאומת",
  "settings_bccs_title": "עותקים מוסתרים",
  "settings_bounces_description": "הפעלת הודעות החזרה שולחת לנו התראות על הודעות הדוא\"ל שלכם שחזרו. כדי לקבל בעצמכם את כל התראות ההחזרה שלכם, השביתו את האפשרות הזו.",
  "settings_bounces_title": "ניהול החזרות",
  "settings_click_tracking": "מעקב אחר קליקים",
  "settings_click_tracking_description": "מעקב אחר קליקים מתעד את כל הקליקים שנעשו על כל קישור בהודעות הדוא\"ל שלכם.",
  "settings_dns_bar_description": "יש להוסיף גם רשומות SPF וגם DKIM לכל הדומיינים של כתובות דוא\"ל השולח שלכם.",
  "settings_dns_bar_dkim_description": "ניתן להוסיף רשומת DKIM בתור רשומת TXT על ידי הוספת הפריטים הבאים:",
  "settings_dns_bar_dkim_title": "רשומות DKIM",
  "settings_dns_bar_domainaut": "אימות דומיין",
  "settings_dns_bar_domainaut_description": "אפשרו ל-TurboSMTP לשלוח הודעות דוא\"ל בשמכם.",
  "settings_dns_bar_spf_description": "הוסיפו את רשומת ה-TXT הבאה לדומיין של כתובת המעטפת (example.com), באחד משני המקרים הבאים:",
  "settings_dns_bar_spf_description_a": "<strong>אם רשומת ה-SPF כבר הוצבה בדומיין שלכם</strong>, ערכו את הרשומה על ידי הוספה",
  "settings_dns_bar_spf_description_b": "אחרי המחרוזת",
  "settings_dns_bar_spf_description_c": "הערה: אל תשכחו להקליד רווח לפני ואחרי התוספות.",
  "settings_dns_bar_spf_description_d": "<strong>אם אין SPF</strong>, פשוט צרו אחד והזינו את הפרטים בתור רשומת TXT DNS.",
  "settings_dns_bar_spf_title": "רשומת SPF",
  "settings_dns_bar_title": "הגדרות DNS",
  "settings_dns_description": "הוסיפו את רשומות ה-DNS שלנו לדומיין שלכם כדי לחתום על הודעות הדוא\"ל שלכם עם DKIM ולהבטיח מסירה מיטבית.",
  "settings_dns_title": "רשומות DNS",
  "settings_email_body_tip": "אנא ציינו <% body %> בקלט שלכם.",
  "settings_email_elements": "רכיבי דוא\"ל",
  "settings_email_footers_added": "כותרת תחתונה נוספה בהצלחה",
  "settings_email_footers_confirm_delete_label": "אישור פעולה",
  "settings_email_footers_confirm_delete_text": "האם אתם בטוחים שברצונכם למחוק כותרת תחתונה זו?",
  "settings_email_footers_default": "הגדרות הכותרת התחתונה עודכנו בהצלחה",
  "settings_email_footers_removed": "הכותרת התחתונה הוסרה בהצלחה",
  "settings_email_footers_updated": "הכותרת התחתונה עודכנה בהצלחה",
  "settings_email_name_tip": "נא לציין שם",
  "settings_email_templates_added": "התבנית נוספה בהצלחה",
  "settings_email_templates_confirm_delete_label": "אישור פעולה",
  "settings_email_templates_confirm_delete_text": "אתם באמת רוצים למחוק תבנית זו?",
  "settings_email_templates_default": "הגדרות התבניות עודכנו בהצלחה",
  "settings_email_templates_removed": "התבנית הוסרה בהצלחה",
  "settings_email_templates_updated": "התבנית עודכנה בהצלחה",
  "settings_email_unsub_added": "קישור לביטול הרשמה נוסף בהצלחה",
  "settings_email_unsub_confirm_delete_label": "אישור פעולה",
  "settings_email_unsub_confirm_delete_text": "האם אתם בטוחים שברצונכם למחוק את הקישור לביטול ההרשמה?",
  "settings_email_unsub_removed": "הקישור לביטול ההרשמה הוסר בהצלחה",
  "settings_email_unsub_updated": "הקישור לביטול ההרשמה עודכן בהצלחה",
  "settings_footers_description": "הוסיפו כותרת תחתונה להודעות הדוא\"ל שלכם.",
  "settings_footers_slide_add": "הוספת כותרת תחתונה",
  "settings_footers_slide_description": "לחצו על \"הוספת כותרת תחתונה\" או ערכו כותרת תחתונה קיימת, ולאחר מכן הזינו את שם הכותרת התחתונה והשלימו את השדות באמצעות HTML או טקסט רגיל.",
  "settings_footers_slide_empty_description": "לחצו על \"הוספת כותרת תחתונה\" או ערכו כותרת תחתונה קיימת, ולאחר מכן הזינו את שם הכותרת התחתונה והשלימו את השדות באמצעות HTML או טקסט רגיל.",
  "settings_footers_slide_empty_title": "אין כותרות תחתונות",
  "settings_footers_slide_htmltext": "טקסט HTML",
  "settings_footers_slide_name": "שם",
  "settings_footers_slide_plaintext": "טקסט פשוט",
  "settings_footers_slide_title": "כותרות תחתונות",
  "settings_footers_title": "כותרות תחתונות",
  "settings_ga_bar_description": "אנא מלאו את השדות הבאים, כולל השם והמקור של נתוני הקמפיין שלכם, כדי להפעיל את שילוב Google Analytics שלכם.",
  "settings_ga_bar_title": "Google Analytics",
  "settings_ga_content": "תוכן הקמפיין",
  "settings_ga_content_mandatory": "תוכן הקמפיין הוא חובה",
  "settings_ga_integrate": "שלבו את Google Analytics כדי לעקוב אחר שיעורי ההמרה שלכם ונתונים אחרים",
  "settings_ga_medium": "אמצעי הקמפיין",
  "settings_ga_medium_mandatory": "אמצעי הקמפיין הוא חובה",
  "settings_ga_name": "שם הקמפיין",
  "settings_ga_name_mandatory": "שם הקמפיין הוא חובה",
  "settings_ga_parameters": "פרמטרים",
  "settings_ga_parameters_description": "אנא מלאו את השדות הבאים, כולל השם והמקור של נתוני הקמפיין שלכם, כדי להפעיל את שילוב Google Analytics שלכם.",
  "settings_ga_source": "מקור הקמפיין",
  "settings_ga_source_mandatory": "מקור הקמפיין הוא חובה",
  "settings_ga_term": "תקופת הקמפיין",
  "settings_ga_term_mandatory": "תקופת הקמפיין היא חובה",
  "settings_google_analytics_description": "Google Analytics עוקבת אחר שיעורי ההמרה שלכם ונתונים אחרים.",
  "settings_google_analytics_title": "Google Analytics",
  "settings_integrations": "שילובים",
  "settings_integrations_dkim_updated": "הגדרות DKIM עודכנו בהצלחה",
  "settings_notification_alert_confirm_delete_label": "אישור פעולה",
  "settings_notification_alert_confirm_delete_text": "האם אתם בטוחים שברצונכם למחוק התראה זו?",
  "settings_notification_bcc_confirm_delete_label": "אישור פעולה",
  "settings_notification_bcc_confirm_delete_success": "ה-{email} מסוג 'עותק מוסתר' נמחק בהצלחה.",
  "settings_notification_bcc_confirm_delete_text": "האם אתם באמת רוצים למחוק את {email} זה מסוג 'עותק מוסתר'?",
  "settings_notification_smtp_auth": "אימות SMTP",
  "settings_notifications": "התראות",
  "settings_notifications_alert_added": "ההתראה נוצרה בהצלחה",
  "settings_notifications_alert_deleted": "ההתראה נמחקה בהצלחה.",
  "settings_notifications_alert_updated": "ההתראה עודכנה בהצלחה",
  "settings_notifications_bcc_emailbox": "זה עתה שלחנו הודעת אימות אל <{email}>.",
  "settings_notifications_bcc_update_success": "ה-{email} מסוג 'עותק מוסתר' עודכן בהצלחה.",
  "settings_notifications_smtp_auth_enabled": "מופעל",
  "settings_notifications_smtp_host": "pro.turbo-smtp.com",
  "settings_notifications_smtp_host_eu": "pro.eu.turbo-smtp.com",
  "settings_notifications_smtp_passvalue": "*********<br>(הסיסמה שסיפקתם בעת ההרשמה)",
  "settings_notifications_smtp_password": "סיסמת SMTP",
  "settings_notifications_smtp_ports": "יציאות SMTP",
  "settings_notifications_smtp_server": "שרת SMTP",
  "settings_notifications_smtp_username": "שם משתמש SMTP",
  "settings_open_tracking": "מעקב פתוח",
  "settings_open_tracking_description": "הפעלת מעקב פתוח תיצור תיעוד של ההודעות הפתוחות שלכם, מה שיאפשר לכם לעקוב טוב יותר אחר תוצאות הקמפיין.",
  "settings_setting_changed": "ההגדרה השתנתה {service}",
  "settings_setting_disabled": "ההגדרה הושבתה {service}",
  "settings_setting_enabled": "ההגדרה הופעלה {service}",
  "settings_setting_notdisabled": "לא ניתן להפעיל את הגדרת {service}.",
  "settings_setting_notenabled": "לא ניתן להפעיל את הגדרת {service}.",
  "settings_setting_webhook_notenabled": "וובהוקים להתראות על אירועים זמינים בתוכניות חוזרות מסוג PRO בלבד.",
  "settings_smtp_description": "כדי להתחבר באמצעות SMTP, הגדירו את ה-SMTP בתוכנת הדואר שלכם או בכל אפליקציית דיוור אחרת על ידי הוספת הפרמטרים הבאים. לחצו על לחצן \"עוד\" כדי לראות את הפרמטרים.",
  "settings_smtp_slide_description": "הגדירו SMTP בתוכנת הדואר שלכם, או בכל אפליקציית דיוור אחרת, על ידי הוספת הפרמטרים הבאים.",
  "settings_smtp_slide_description_api": "שם המשתמש והסיסמה לאימות SMTP הם זוג מפתחות API: השתמש ב-Consumer Key כשם המשתמש של SMTP וב-Consumer Secret כסיסמת SMTP. יש להתייחס אליהם כנתוני אימות שיש לשמור בסוד ולהחליף בעת הצורך.",
  "settings_smtp_slide_parameter": "פרמטר",
  "settings_smtp_slide_title": "התחברות באמצעות SMTP",
  "settings_smtp_slide_value": "ערך",
  "settings_smtp_title": "התחברות באמצעות SMTP",
  "settings_template_description": "תבניות הן הכלי המושלם שייתן לדוא\"ל שלכם פריסה יעילה בקלות.",
  "settings_template_slide_add": "הוספת תבנית",
  "settings_template_slide_default": "ברירת מחדל",
  "settings_template_slide_description": "לחצו על \"הוספת תבנית\" והשלימו את השדות עם המידע הנדרש, כולל שם התבנית ו-HTML או טקסט רגיל.",
  "settings_template_slide_empty_description": "לחצו על \"הוספת תבנית\" והשלימו את השדות עם המידע הנדרש, כולל שם התבנית ו-HTML או טקסט רגיל.",
  "settings_template_slide_empty_title": "הוספת תבנית",
  "settings_template_slide_html": "גרסת HTML",
  "settings_template_slide_info": "<% body %> הוא חובה בטקסט HTML ובטקסט רגיל. מציין המיקום יוחלף בתוכן אמיתי.",
  "settings_template_slide_name": "שם תבנית",
  "settings_template_slide_plaintext": "גרסת טקסט רגיל",
  "settings_template_slide_title": "תבניות",
  "settings_template_title": "תבניות",
  "settings_title": "הגדרות",
  "settings_tracking": "מעקב",
  "settings_unsubscribe_description": "הוסיפו קישור לביטול ההרשמה בתחתית הודעות דוא\"ל טקסט ו-HTML. לא יימסרו הודעות דוא\"ל למשתמשים שביטלו את הרשמתם.",
  "settings_unsubscribe_select": "בחרו שפה",
  "settings_unsubscribe_slide_add": "הוספת קישור לביטול ההרשמה",
  "settings_unsubscribe_slide_description": "הוסיפו קישור לביטול ההרשמה בתחתית הודעות דוא\"ל טקסט ו-HTML. לא יימסרו הודעות דוא\"ל למשתמשים שביטלו את הרשמתם. ביטולי הרשמה יטופלו אוטומטית ובזמן אמת כדי לשפר את מוניטין שליחת הדוא\"ל שלכם. הזינו את הטקסט שבו ברצונכם להשתמש (כגון \"כדי לבטל את הרישום, לחצו כאן\") ולאחר מכן הדביקו את הטקסט במציין המיקום בהודעה שלכם.",
  "settings_unsubscribe_slide_empty": "הוספת קישור לביטול ההרשמה",
  "settings_unsubscribe_slide_empty_description": "הוסיפו קישור לביטול ההרשמה בתחתית הודעות דוא\"ל טקסט ו-HTML. לא יימסרו הודעות דוא\"ל למשתמשים שביטלו את הרשמתם. ביטולי הרשמה יטופלו אוטומטית ובזמן אמת כדי לשפר את מוניטין שליחת הדוא\"ל שלכם.",
  "settings_unsubscribe_slide_language": "בחרו שפה",
  "settings_unsubscribe_slide_placeholder": "מציין מיקום",
  "settings_unsubscribe_slide_text": "טקסט ביטול ההרשמה",
  "settings_unsubscribe_slide_title": "קישור לביטול ההרשמה",
  "settings_unsubscribe_text": "טקסט",
  "settings_unsubscribe_title": "קישור לביטול ההרשמה",
  "settings_unsubscribe_value": "כדי לבטל את הרשמתכם, לחצו כאן.",
  "settings_webhooks_description": "וובהוקים מאפשרים לאפליקציית האינטרנט שלכם לקבל הודעות על משלוח דוא\"ל ואירועי אינטראקציה.",
  "settings_webhooks_slide_bounced": "הוחזרו",
  "settings_webhooks_slide_click": "לחיצה",
  "settings_webhooks_slide_deferred": "נדחו",
  "settings_webhooks_slide_delivered": "נמסרו",
  "settings_webhooks_slide_deliveryevents": "אירועי מסירה",
  "settings_webhooks_slide_description": "באפשרותכם להשתמש בוובהוקים להתראה על אירועים כדי לקבל הודעה על אירועים שקורים בפרויקט הדוא\"ל שלכם מבלי להשתמש בממשקי API.",
  "settings_webhooks_slide_dropped": "בוטלו",
  "settings_webhooks_slide_engagementevents": "אירועי התקשרות",
  "settings_webhooks_slide_inserturl": "הזינו כאן את כתובת ה-URL שתרצו שתקבל הודעה",
  "settings_webhooks_slide_notification": "כתובת ה-URL של התראות וובהוק",
  "settings_webhooks_slide_notification_description": "הפעלת התראות וובהוק",
  "settings_webhooks_slide_open": "פתיחה",
  "settings_webhooks_slide_placeholder": "https://",
  "settings_webhooks_slide_processed": "עובדו",
  "settings_webhooks_slide_spamreport": "דוח דואר זבל",
  "settings_webhooks_slide_title": "וובהוקים",
  "settings_webhooks_slide_unsubscribe": "ביטול הרשמה",
  "settings_webhooks_support": "אנא צרו קשר עם התמיכה ובקשו 'הפעלת אירועי מסירה'.",
  "settings_webhooks_title": "וובהוקים",
  "settings_webhooks_upgrade": "שדרוג לתוכנית PRO",
  "startsWith": "מתחיל ב-",
  "subaccount_policy_agree": "קראתי ואני מסכים/ה <a href=\"https://serversmtp.com/terms-and-conditions/\" target=\"_blank\">לתנאי השירות</a> ו- <a href=\"https://serversmtp.com/privacypolicy-eu-regulation-2016-79-gdpr/\" target=\"_blank\">למדיניות הפרטיות</a>",
  "subaccount_policy_agree_notchecked": "עליכם להסכים לתנאי השירות ולמדיניות הפרטיות.",
  "subaccount_slide_inuse": "בשימוש",
  "subaccount_slide_ip": "כתובת IP",
  "subaccount_slide_ips": "כתובות IP",
  "subaccount_slide_ips_description": "אנא בחרו כתובת IP להקצאה לחשבון המשנה הזה.",
  "subaccounts_action_activated": "{email} הופעל בהצלחה",
  "subaccounts_action_active": "פעיל",
  "subaccounts_action_deactivated": "{email} הושעה בהצלחה",
  "subaccounts_action_delete": "מחיקה",
  "subaccounts_action_deleted": "חשבון המשנה נמחק בהצלחה",
  "subaccounts_action_details": "פרטים",
  "subaccounts_action_edit": "עריכה",
  "subaccounts_action_limit": "הגדרת מגבלות",
  "subaccounts_action_login": "התחברות",
  "subaccounts_action_notdeleted": "שגיאה במחיקת חשבון משנה",
  "subaccounts_action_suspend": "השעיה",
  "subaccounts_active": "פעיל",
  "subaccounts_added_succesfully": "חשבון המשנה נוסף בהצלחה",
  "subaccounts_agencysettings": "הגדרות סוכנות",
  "subaccounts_assigned_ip": "כתובת IP שהוקצתה",
  "subaccounts_changed_succesfully": "חשבון המשנה שונה בהצלחה",
  "subaccounts_confirm_activation_label": "אישור הפעלה",
  "subaccounts_confirm_activation_text": "האם ברצונכם להפעיל את {email}?",
  "subaccounts_confirm_deactivation_label": "אישור ביטול הפעלה",
  "subaccounts_confirm_deactivation_text": "האם ברצונכם להשעות את חשבון המשנה: {email}?",
  "subaccounts_confirm_delete_label": "אישור מחיקה",
  "subaccounts_confirm_delete_text": "האם ברצונכם למחוק את חשבון המשנה {email}?",
  "subaccounts_confirm_login_label": "אישור כניסה",
  "subaccounts_confirm_login_text": "האם אתם בטוחים שברצונכם להתנתק מהחשבון הנוכחי ולהיכנס אל {email}?",
  "subaccounts_confirmation": "אישור",
  "subaccounts_create_warning": "יצירת חשבונות משנה חדשים זמינה רק במנויים מקצועיים.",
  "subaccounts_email": "כתובת דוא\"ל של החשבון",
  "subaccounts_empty": "הגדילו את העסק שלכם והציעו ללקוחות שלכם שירות מקצועי הניתן להתאמה אישית מלאה עם המותג שלכם, או חלקו את כתובות הדוא\"ל שלכם בין העובדים והקולגות שלכם.<br>ממשק ניהול פשוט יאפשר לכם לעקוב אחר תעבורה וסטטיסטיקות.",
  "subaccounts_expiration_date": "תאריך התפוגה",
  "subaccounts_inactive": "לא פעיל",
  "subaccounts_ip": "כתובת IP",
  "subaccounts_last_activity": "פעילות אחרונה",
  "subaccounts_limits_nolimits": "ללא הגבלה",
  "subaccounts_limits_sending": "מגבלת שליחה:",
  "subaccounts_limits_slide_description": "הגדירו מגבלה עבור חשבון המשנה שלכם.",
  "subaccounts_limits_slide_limits": "מגבלות",
  "subaccounts_limits_slide_noplan_expiration": "ללא תפוגה",
  "subaccounts_limits_slide_plan_expiration": "תפוגת התוכנית",
  "subaccounts_limits_slide_set_plan_expiration": "הגדירו את תפוגת התוכנית",
  "subaccounts_limits_slide_this_number": "מספר זה מתייחס לתקופה",
  "subaccounts_limits_slide_title": "מגבלות חשבונות משנה",
  "subaccounts_no_expiration": "({master_expiration_date}) <i class=\"pi pi-info-circle\"></i>",
  "subaccounts_no_expiration_tooltip": "לפי התפוגה של תוכנית החשבון הראשי",
  "subaccounts_settings_update": "הגדרות חשבון המשנה מעודכנות כעת.",
  "subaccounts_slide_account_confirm": "אשרו את פרטי החשבון",
  "subaccounts_slide_account_description": "לחצו על לחצן העריכה כדי לשנות את פרטי המשתמש שלכם בחשבון המשנה.",
  "subaccounts_slide_account_info": "פרטי חשבון",
  "subaccounts_slide_address": "כתובת",
  "subaccounts_slide_address2": "כתובת 2",
  "subaccounts_slide_change_password": "הגדרת סיסמה",
  "subaccounts_slide_city": "עיר",
  "subaccounts_slide_company": "שם חברה",
  "subaccounts_slide_confirm_password": "אימות סיסמה",
  "subaccounts_slide_confirmpassword_different": "אנא ודאו שהסיסמאות שלכם תואמות.",
  "subaccounts_slide_country": "מדינה",
  "subaccounts_slide_email": "כתובת דוא\"ל",
  "subaccounts_slide_email_not_unique": "כתובת הדוא\"ל הזו כבר נמצאת בשימוש.",
  "subaccounts_slide_email_required": "אנא הזינו כתובת דוא\"ל",
  "subaccounts_slide_first_name": "שם פרטי",
  "subaccounts_slide_firstname_required": "חובה למלא שם פרטי.",
  "subaccounts_slide_last_name": "שם משפחה",
  "subaccounts_slide_lastname_required": "‫חובה למלא שם משפחה.",
  "subaccounts_slide_password": "סיסמה",
  "subaccounts_slide_password_details": "השאירו את שדה הסיסמה ריק כדי להמשיך להשתמש בסיסמה הנוכחית שלכם.",
  "subaccounts_slide_password_minlength": "על אורך הסיסמה להיות לפחות {req}. כרגע הוא: {act}.",
  "subaccounts_slide_password_required": "דרושה סיסמה.",
  "subaccounts_slide_password_pattern": "הסיסמה חייבת להכיל לפחות 10 תווים, מהם לפחות אחד גדול, אחד קטן ואחד ספרה",
  "subaccounts_slide_phone": "טלפון",
  "subaccounts_slide_profile_information": "פרטי הפרופיל",
  "subaccounts_slide_region": "מדינה/אזור/מחוז",
  "subaccounts_slide_website": "אתר",
  "subaccounts_slide_zip": "מיקוד",
  "subaccounts_status": "סטטוס",
  "subaccounts_subaccounts": "רשימת חשבונות משנה",
  "subaccounts_title": "חשבונות משנה",
  "subaccounts_unlimited": "ללא הגבלה <i class='pi pi-info-circle'></i>",
  "subaccounts_unlimited_tooltip": "לפי מגבלת תוכנית החשבון הראשי.",
  "subaccounts_usage": "שימוש",
  "sunday": "יום ראשון",
  "suppression_deleted": "החסימות יימחקו בקרוב.",
  "suppression_filters_reason": "סיבה",
  "suppression_filters_recipient": "נמען",
  "suppression_filters_sender": "שולח",
  "suppression_filters_sources": "מקורות",
  "suppression_filters_subject": "נושא הודעת הדוא\"ל",
  "suppression_operators_exclude": "החרגה",
  "suppression_operators_include": "הכללה",
  "suppression_table_addcolumn_sender": "שולח",
  "suppression_table_dropdown_text": "{first} - {last} מתוך {totalRecords}",
  "suppression_types_bounce": "הוחזרו",
  "suppression_types_manual": "ידני",
  "suppression_types_spam": "דואר זבל",
  "suppression_types_unsubscribe": "ההרשמה בוטלה",
  "suppression_types_validation_failed": "האימות נכשל",
  "suppressions_add_form_errors": "שגיאות טפסים",
  "suppressions_add_form_nofile_selected": "לא נבחר אף קובץ",
  "suppressions_add_suppression": "יבוא חסימות",
  "suppressions_choose_columns": "בחרו עמודות",
  "suppressions_confirm_delete_all_label": "אישור פעולה",
  "suppressions_confirm_delete_all_text": "האם אתם באמת רוצים למחוק את כל החסימות בין <strong>{from}</strong> ל-<strong>{to}</strong>?",
  "suppressions_confirm_delete_all_type_text": "האם אתם באמת רוצים למחוק את<br> כל <strong>החסימות מסוג </strong>{type} בין <strong>{from}</strong> ל-<strong>{to}</strong>?",
  "suppressions_confirm_delete_filtered_label": "אישור פעולה",
  "suppressions_confirm_delete_filtered_text": "האם אתם באמת רוצים למחוק את כל <strong>החסימות המסוננות</strong>? <br><small>*רשומות דואר זבל לא יימחקו.</small>",
  "suppressions_confirm_delete_selected_label": "אישור פעולה",
  "suppressions_confirm_delete_selected_text": "האם אתם באמת רוצים למחוק את החסימות שנבחרו?",
  "suppressions_date": "תאריך",
  "suppressions_delete_all": "למחוק הכל",
  "suppressions_delete_selected": "למחוק את הבחירה",
  "suppressions_deleted": "החסימות יימחקו בקרוב.",
  "suppressions_description_empty": "לא נמצאו רשומות עבור התקופה שנבחרה.",
  "suppressions_details_date": "תאריך",
  "suppressions_details_entry": "רשומה",
  "suppressions_details_reason": "סיבה",
  "suppressions_details_sender": "שולח",
  "suppressions_details_title": "פרטים",
  "suppressions_details_type": "סוג",
  "suppressions_imported": "החסימות שלכם ייובאו בקרוב.",
  "suppressions_imported_partial": "{imported} מתוך {total} חסימות ייובאו בקרוב.",
  "suppressions_include": "הכללה",
  "suppressions_modal_confirm": "אישור",
  "suppressions_not_imported": "חסימות לא ייובאו עקב כתובות דוא\"ל שגויות.",
  "suppressions_reason": "סיבה",
  "suppressions_recipient": "נמען",
  "suppressions_title": "חסימות",
  "suppressions_title_empty": "לא נמצאו חסימות",
  "suppressions_type": "סוג",
  "t_api": "תיעוד API",
  "t_knowledgebase": "מאגר מידע",
  "t_logout": "התנתקות",
  "table_dropdown_goto": "מעבר לדף",
  "table_dropdown_text": "{first} - {last} מתוך {totalRecords}",
  "thursday": "יום חמישי",
  "toggle_off": "מושבת",
  "toggle_on": "מופעל",
  "token_can_not_be_empty": "האסימון לא יכול להיות ריק",
  "token_is_missing": "האסימון חסר",
  "tuesday": "יום שלישי",
  "unlimited": "לא מוגבל",
  "upload": "העלאה",
  "upload_add_manually": "הוספה ידנית",
  "upload_add_manually_description": "העתיקו והדביקו מספר כתובות דוא\"ל בכמות גדולה באזור למטה, מופרדות על ידי קו סיום. כדי לזכור מדוע הוספתם את אנשי הקשר וכדי לסייע בחיפושים עתידיים, הוסיפו סיבה לחסימת הכתובות הללו.",
  "upload_add_manually_placheholder": "email1,email2,email3,email4,email5...",
  "upload_add_reason": "הזינו סיבה לחסימת כתובות אלה.",
  "upload_allowed_files": "הפורמטים המותרים של הקבצים הם csv או txt.",
  "upload_dd_here": "גררו ושחררו את הקובץ שלכם כאן",
  "upload_import_from_file": "ייבוא מקובץ",
  "upload_import_from_file_description": "על הקובץ להיות עמודה אחת המכילה את כל כתובות הדוא\"ל שברצונכם לייבא. כדי לזכור מדוע הוספתם את אנשי הקשר וכדי לסייע בחיפושים עתידיים, הוסיפו סיבה לחסימת הכתובות הללו.",
  "wednesday": "יום רביעי",
  "whitelabel_agencyname": "שם הסוכנות",
  "whitelabel_companydetails": "פרטי החברה",
  "whitelabel_description": "אם פתחתם חשבון משנה ואתם משווקים רשמיים של turboSMTP, התאמה אישית של המוצר עם הלוגו ופרטי החברה שלכם תעניק ללקוחות את חווית המותג שלכם.",
  "whitelabel_footer": "כותרת תחתונה של הסוכנות",
  "whitelabel_footer_description": "הזינו את קוד ה-HTML שיוצג בכותרת התחתונה.",
  "whitelabel_logo": "לוגו החברה",
  "whitelabel_logo_description": "גודל תמונה מקסימלי מותר: 472x72 פיקסלים",
  "whitelabel_reset_default_image": "שחזור תמונת ברירת מחדל",
  "whitelabel_upload_image": "העלאת תמונה",
  "whitelabel_upload_in_progress": "ההעלאה מתבצעת",
  "missing_settings_required": "חלק מההגדרות נדרשות לפני הפעלתו",
  "settings_apikeys_allowed_ips": "כתובות IP מורשות:",
  "settings_bccs_missing_required": "אנא וודא שהגדרת BCC אחת כבר קיימת לפני הפעלתו",
  "settings_bccs_notifications_default": "האימייל המוגדר כברירת מחדל של BCC עודכן בהצלחה",
  "forgot_password_use_different_password": "בבקשה, צור סיסמה חדשה שאינה דומה לסיסמאות קודמות, על מנת להגביר את בטחון החשבון שלך.",
  "no_records_found": "רשומת DNS לא נמצאה. ודא שהרשומה פורסמה כראוי ושההפצה הושלמה.",
  "invalid_record_found": "נמצאה רשומת DNS, אך נראה כי היא מעוצבת באופן לא נכון או מכילה ערך לא חוקי.",
  "too_many_dns_lookups": "ברשומת SPF יש יותר מ-10 חיפושי DNS מותרים, דבר העלול לגרום לבעיות במשלוח האימיילים.",
  "more_than_spf_entry_found": "נמצאו מספר רשומות SPF עבור הדומיין שלך. רק רשומת SPF אחת מותרת לדומיין.",
  "notice": "אזהרה",
  "settings_sender_domains_no_option": "<p>החשבון שלך כרגע פועל ב\"מצב סטנדרטי\", <strong>תצורה ישנה יותר</strong> שבה כל האימיילים היוצאים מתארזים מחדש עם הכתובת שלנו, ללא קשר להגדרות SPF, DKIM, ו-DMARC שלך.</p>\n<p>כדי לשפר את יכולת המסירה של אימיילים, אנו ממליצים בחום לבחור אחת מאפשרויות התמוטטות המעודכנות הזמינות.</p>",
  "failed_to_get_a_aaaa_record": "נכשל בקבלת רשומות A / AAAA עבור {domain_name}",
  "invalid_spf_syntax": "תחביר SPF לא חוקי",
  "spf_has_upper_case_letters": "רשומת ה-SPF אינה יכולה להכיל אותיות רישיות. אנא ודא כי כל התווים הם באותיות קטנות בהתאם לתקן ה-SPF.",
  "recursive_include_detected": "רשומת ה-SPF שלך לא צריכה לכלול את הדומיין עצמו מכיוון שזה יוצר לולאה שמובילה לחיפושי DNS אינסופיים. אנא בדוק מחדש את רשומת ה-SPF כדי להסיר את ההתייחסות לדומיין כדי למנוע תלות מעגלית ולהישמע לתקן ה-SPF.",
  "spf_longer_than_255_characters": "רשומת ה-SPF חורגת מהמגבלה של 255 תווים למחרוזת טקסט DNS בודדת. כדי לעמוד במפרטי ה-DNS, נא פצל את רשומת ה-SPF שלך למספר מחרוזות, כל אחת מהן לא תעלה על 255 תווים, או קצר את הרשומה כדי לעמוד במגבלה.",
  "ptr_mechanism_not_allowed": "לשיפור ביצועי SPF וקידום אימוץ של מעשי ודאות שולחים חסינים, מומלץ להימנע משימוש במנגנון ptr ולהסתמך במקום על מנגנונים כגון ip4 ו-include.",
  "data_location_modal_title": "מיקום נתונים",
  "data_location_network_servers": "שרתי רשת",
  "data_location_ip_location": "מיקום IP",
  "data_location_company_managing_data": "חברה המנהלת נתונים",
  "data_location_network_servers_value": "מילאנו (IT), פרנקפורט (DE), אמסטרדם (NL)",
  "data_location_ip_location_value": "אירופה RI.PE",
  "data_location_company_managing_data_value": "Edisplay Srl, איטליה EU",
  "data_location_no_transfer_outside_eu": "לא מועברים נתונים מחוץ לאיחוד האירופי",
  "gdpr_data_location": "כל הנתונים ב-EU",
  "gdpr_see_details": "פרטים",
  "settings_apikeys_ips_label": "הגבלת IP",
  "settings_apikeys_permissions_label": "הרשאות API",
  "settings_apikeys_permissions_description": "בחר את השירותים שמפתח ה-API הזה יוכל לגשת אליהם.",
  "settings_apikeys_permission_send_smtp": "שליחת SMTP",
  "settings_apikeys_permission_send_api": "שליחת HTTP API",
  "settings_apikeys_permission_apis": "סטטיסטיקות וממשקי API לניהול",
  "settings_apikeys_permissions_required": "אנא בחר לפחות אפשרות אחת",
  "settings_apikeys_legacy_key_alert_message": "עדכנו את <strong>אימות ה-SMTP</strong> שלנו כדי להשתמש <strong>במפתחות API</strong> במקום בסיסמת החשבון שלך. כדי להבטיח מעבר חלק, <strong>יצרנו עבורך מפתח API מיוחד</strong> התואם את האישורים הישנים שלך. לאבטחה משופרת, אנו ממליצים בחום <strong>למחוק מפתח זה וליצור מפתח חדש</strong> לשימוש בהגדרות ה-SMTP שלך.",
  "settings_apikeys_legacy_key_alert_link": "מידע נוסף",
  "settings_apikeys_apikey_new_success": "מפתח API נוצר!",
  "settings_apikeys_apikey_secret": "Consumer Secret",
  "settings_apikeys_apikey_new_security": "<strong>Consumer Secret</strong> זה מוצג רק כאן ולא יוצג שוב מסיבות בטיחותיות. אנא שמור אותו במקום בטוח.",
  "settings_apikeys_apikey_new_security_copy_cta": "העתק ל-clipboard",
  "settings_apikeys_apikey_new_security_copied_success": "הועתק!",
  "settings_apikeys_apikey_new_security_error": "כשל בהעתקה",
  "settings_apikeys_action_regenerate_secret": "יצירת Consumer Secret חדש",
  "settings_apikeys_action_regenerate_secret_confirmation_message": "על ידי יצירת Consumer Secret חדש, כל הקודים שמשתמשים במפתח הקיים יפסיקו לעבוד.",
  "settings_apikeys_action_regenerate_secret_confirmation": "אני מבין/ה, צור Consumer Secret חדש",
  "settings_apikeys_action_regenerate_secret_success": "Consumer Secret חדש נוצר!",
  "not_included_in_plan": "לא כלול בתוכנית הנוכחית שלך",
  "registration_logout": "התנתק",
  "registration_step_personal": "פרטים אישיים",
  "registration_step_company": "פרטי חברה",
  "registration_step_address": "כתובת",
  "registration_label_email": "אימייל",
  "registration_label_firstname": "שם פרטי",
  "registration_label_lastname": "שם משפחה",
  "registration_label_company": "חברה",
  "registration_label_vat": "מס ח.פ.",
  "registration_label_vat_optional": "(אופציונלי)",
  "registration_label_phone": "מספר טלפון",
  "registration_label_website": "אתר אינטרנט",
  "registration_label_website_hint": "(אופציונלי)",
  "registration_label_address": "כתובת",
  "registration_label_city": "עיר",
  "registration_label_country": "מדינה",
  "registration_placeholder_country": "בחר מדינה",
  "registration_label_region": "מחוז / אזור",
  "registration_placeholder_region": "בחר אזור",
  "registration_label_zip": "מיקוד",
  "registration_btn_back": "חזרה",
  "registration_btn_next": "השלב הבא",
  "registration_btn_complete": "השלם פרופיל",
  "registration_error_firstname": "שם פרטי הוא חובה.",
  "registration_error_lastname": "שם משפחה הוא חובה.",
  "registration_error_company": "שם החברה הוא חובה.",
  "registration_error_phone": "מספר טלפון הוא חובה.",
  "registration_error_website": "אנא הזן כתובת URL תקינה.",
  "registration_error_address": "כתובת היא חובה.",
  "registration_error_city": "עיר היא חובה.",
  "registration_error_country": "מדינה היא חובה.",
  "registration_error_region": "אזור הוא חובה.",
  "registration_error_zip": "מיקוד הוא חובה.",
  "registration_error_phone_format": "מספר הטלפון חייב להכיל ספרות בלבד.",
  "registration_address_message": "על ידי הבטחת דיוק כתובת הדואר שלך, תוכל ליהנות מ<strong>חווית הפעלה מואצת</strong>.",
  "registration_step_confirmation": "אישור",
  "registration_confirmation_title": "הפרופיל הושלם!",
  "registration_confirmation_message": "חשבונך נוצר בהצלחה.<br>כעת תוכל לרכוש תוכנית כדי לפתוח תכונות מתקדמות ומכסות שליחה גבוהות יותר",
  "registration_confirmation_message_buy": "חשבונך נוצר בהצלחה.",
  "registration_btn_buy_plan": "רכישת תוכנית",
  "registration_stay_free": "הישאר בגרסה החינמית, תוכל לשדרג מאוחר יותר",
  "registration_btn_dashboard": "מעבר ללוח הבקרה",
  "registration_redirect_to_shop": "תועבר לתהליך התשלום בעוד רגע...",
  "registration_go_to_shop": "לחץ כאן כדי להמשיך לתשלום"
}
